import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export const getOrgPipelinesOnFounder = async () => fetcher.get({
  path: '/pipeline/organization',
});

export const createInvestorOnFounder = async (data) => fetcher.post({
  path: '/pipeline',
  body: data,
});

export const updateInvestorOnFounder = async (pipelineItemId, data) => fetcher.put({
  path: `/pipeline/${pipelineItemId}`,
  body: data,
});

export const deleteInvestorOnFounder = async (id) => fetcher.delete({
  path: '/pipeline',
  body: {
    id,
  },
});
